(function () {
  class unlocksIntroPanel extends PIXI.Container {
    constructor() {
      super();
      this._completeCallback;
      StateMachine.Create(this);
    }

    initialise() {
      this._jsonPath = "unlocksIntroPanel:unlocksIntroPanelContainer:unlocksContainerPanel";
      this._popupPanel = undefined;
      this._introPanel = undefined;
      this._panelMask = undefined;
      this._skipButton = undefined;
      this._idleAnim = undefined;
      this._devilLevel = 1;
      this._callback = undefined;

      messageBus.subscribe("spinner:GameConfigEvent", this.onGameConfigEvent.bind(this));
    }

    onGameConfigEvent(task) {
      this._popupPanel = resourceManager.get(this._jsonPath);
      this._popupPanel.visible = false;

      this._continueText = resourceManager.get(this._jsonPath + ":continueContainer");
      this._continueText.alpha = 0;

      this._skipButton = resourceManager.get("unlocksIntroPanel:unlocksIntroPanelContainer:darkOverlay");
      this._skipButton.interactive = false;
      this._skipButton.alpha = 0;
      this._skipButton.mousedown = this._skipButton.touchstart = this.skipPressed.bind(this);

      this._devils = {};
      this._devils.boost = resourceManager.get(this._jsonPath + ":boostDevil");
      this._devils.multi = resourceManager.get(this._jsonPath + ":multiDevil");
      this._devils.respin = resourceManager.get(this._jsonPath + ":respinDevil");
      Object.values(this._devils).forEach((devil) => {
        devil.alpha = 0.3;
      });
    }

    startPopup(devilLevel, callback) {
      this._devilLevel = devilLevel;
      this._callback = callback;

      if (this._devilLevel === 1) {
        this._callback();
        return;
      }

      resourceManager.getContainer("unlocksIntroContainer").visible = true;

      this._popupPanel.scale.set(0.5);
      this._popupPanel.alpha = 0;
      this._popupPanel.visible = true;

      gsap.to(this._skipButton, {
        duration: 0.3,
        alpha: 0.8,
      });

      gsap.to(this._popupPanel, {
        duration: 0.4,
        pixi: { scaleX: 1, scaleY: 1 },
        alpha: 1,
        ease: "power1.out",
        onComplete: () => {
          this.performUnlocks(() => {
            this._skipButton.interactive = true;
            this.idleAnim();
          });
        },
      });
    }

    performUnlocks(callback) {
      const devils = [this._devils.boost, this._devils.multi, this._devils.respin];

      const delay = 0.5;
      let delayInt = 0;

      for (let i = 0; i < this._devilLevel - 1; i++) {
        const devil = devils[i];

        gsap
          .timeline()
          .to(devil, {
            duration: 0.2,
            delay: delayInt,
            alpha: 1,
            onStart: () => {
              soundManager.play(`winline${i + 1}`);
            },
          })
          .to(
            devil,
            {
              duration: 0.4,
              pixi: { scaleX: 1.05, scaleY: 1.05 },
              ease: "power1.inOut",
              repeat: 1,
              yoyo: true,
              onComplete: () => {
                if (i === this._devilLevel - 2) {
                  gsap.to(this._continueText, {
                    duration: 0.3,
                    alpha: 1,
                  });

                  callback();
                }
              },
            },
            "<"
          );

        delayInt += delay;
      }
    }

    idleAnim() {
      this._idleAnim = gsap.to(this._continueText, {
        duration: 0.8,
        pixi: { scaleX: 1.1, scaleY: 1.1 },
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }

    endPopup() {
      this._callback();

      gsap.to(this._skipButton, {
        duration: 0.3,
        alpha: 0,
      });

      gsap.to(this._popupPanel, {
        duration: 0.4,
        pixi: { scaleX: 0.5, scaleY: 0.5 },
        alpha: 0,
        ease: "power1.in",
        onComplete: () => {
          resourceManager.getContainer("unlocksIntroContainer").visible = false;
        },
      });
    }

    skipPressed() {
      if (this._idleAnim) {
        this._idleAnim.kill();
        this._idleAnim = undefined;
      }

      if (this._skipButton.interactive) {
        this._skipButton.interactive = false;
        this.endPopup();
      }
    }
  }

  create = function (json) {
    return new unlocksIntroPanel();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType("unlocksIntroPanel", create, initialise, getFilesRequired);
})();
